import { Outlet } from 'react-router-dom';

// project imports
// import AuthGuard from '../../utils/route-guard/AuthGuard';
// ==============================|| LAYOUT - AUTH ||============================== //

export default function AuthLayout() {
  return (
    // <AuthGuard>
    <Outlet />
    // </AuthGuard>
  );
}
